import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCourt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"court"} maskId="square-filled-radius-0-stroke-1-IconCourt"><path d="M12 1.97461L21 4.88637V10.0001H18.5L18.5 19H17.5L17.5 10.0001H14.5L14.5 19H13.5L13.5 10.0001H10.5L10.5 19H9.5L9.5 10.0001H6.5L6.5 19H5.5L5.5 10.0001H3V4.88637L12 1.97461Z" fill="currentColor"/><path d="M21.25 20H3V21H21.25V20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCourt;
